var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignupbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 353,
    height: 970,
    viewBox: "0 0 353 970",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_4024)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M951.644 -342.325C1062.4 -261.161 1240.55 -64.3323 1067.11 73.6733C850.322 246.18 392.968 378.021 502.151 928.13",
    stroke: "url(#paint0_linear_49_4024)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M930.111 -362.802C1040.86 -281.638 1219.01 -84.8089 1045.58 53.1967C828.789 225.704 371.435 357.544 480.618 907.653",
    stroke: "url(#paint1_linear_49_4024)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M908.577 -383.279C1019.33 -302.115 1197.48 -105.286 1024.05 32.7201C807.256 205.227 349.902 337.067 459.084 887.177",
    stroke: "url(#paint2_linear_49_4024)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M887.042 -403.755C997.796 -322.591 1175.94 -125.762 1002.51 12.2434C785.721 184.75 328.367 316.591 437.549 866.7",
    stroke: "url(#paint3_linear_49_4024)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M865.509 -424.232C976.263 -343.068 1154.41 -146.239 980.978 -8.23318C764.187 164.274 306.834 296.114 416.016 846.224",
    stroke: "url(#paint4_linear_49_4024)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M843.976 -444.708C954.729 -363.545 1132.88 -166.715 959.445 -28.7099C742.654 143.797 285.3 275.637 394.483 825.747",
    stroke: "url(#paint5_linear_49_4024)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.443 -465.185C933.196 -384.021 1111.34 -187.192 937.912 -49.1866C721.121 123.32 263.767 255.161 372.95 805.27",
    stroke: "url(#paint6_linear_49_4024)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M800.91 -485.662C911.663 -404.498 1089.81 -207.669 916.379 -69.6631C699.588 102.844 242.234 234.684 351.416 784.794",
    stroke: "url(#paint7_linear_49_4024)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M779.376 -506.138C890.13 -424.975 1068.28 -228.145 894.846 -90.1398C678.055 82.3672 220.701 214.207 329.883 764.317",
    stroke: "url(#paint8_linear_49_4024)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M757.843 -526.615C868.597 -445.451 1046.75 -248.622 873.312 -110.616C656.521 61.8906 199.168 193.731 308.35 743.84",
    stroke: "url(#paint9_linear_49_4024)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M736.31 -547.092C847.063 -465.928 1025.21 -269.099 851.779 -131.093C634.988 41.414 177.634 173.254 286.817 723.364",
    stroke: "url(#paint10_linear_49_4024)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M714.777 -567.568C825.53 -486.405 1003.68 -289.575 830.246 -151.57C613.455 20.9372 156.101 152.777 265.284 702.887",
    stroke: "url(#paint11_linear_49_4024)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M693.244 -588.045C803.997 -506.881 982.146 -310.052 808.713 -172.046C591.922 0.460625 134.568 132.301 243.75 682.41",
    stroke: "url(#paint12_linear_49_4024)",
    strokeWidth: 4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_49_4024",
    x1: 250.444,
    y1: 492.162,
    x2: 1180.91,
    y2: -45.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_49_4024",
    x1: 228.911,
    y1: 471.685,
    x2: 1159.38,
    y2: -65.5196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_49_4024",
    x1: 207.378,
    y1: 451.209,
    x2: 1137.84,
    y2: -85.9963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_49_4024",
    x1: 185.843,
    y1: 430.732,
    x2: 1116.31,
    y2: -106.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_49_4024",
    x1: 164.31,
    y1: 410.256,
    x2: 1094.78,
    y2: -126.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_49_4024",
    x1: 142.776,
    y1: 389.779,
    x2: 1073.24,
    y2: -147.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_49_4024",
    x1: 121.243,
    y1: 369.302,
    x2: 1051.71,
    y2: -167.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_49_4024",
    x1: 99.7101,
    y1: 348.826,
    x2: 1030.18,
    y2: -188.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_49_4024",
    x1: 78.1769,
    y1: 328.349,
    x2: 1008.64,
    y2: -208.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_49_4024",
    x1: 56.6437,
    y1: 307.872,
    x2: 987.11,
    y2: -229.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_49_4024",
    x1: 35.1105,
    y1: 287.396,
    x2: 965.577,
    y2: -249.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_49_4024",
    x1: 13.5773,
    y1: 266.919,
    x2: 944.044,
    y2: -270.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_49_4024",
    x1: -7.95593,
    y1: 246.442,
    x2: 922.511,
    y2: -290.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_4024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 510,
    height: 982,
    rx: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupbg);
export default __webpack_public_path__ + "static/media/signupbg.405b2b7e3a49db20d26b84c0046eaa36.svg";
export { ForwardRef as ReactComponent };